import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getCompanies } from '../../actions/companies-actions';
import { BsFillTrashFill } from "react-icons/bs";
import { searchListQuery } from '../../actions/global-actions';
import Paginator from '../../components/paginator/paginator';

function CompaniesList(){
    const currentLink = "/aseguradoras";
    const dispatch = useDispatch();
    const [companies, setCompanies] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [skip, setSkip] = useState(0);
    const [searchData, setSearchData] = useState({
        isSearching: false,
        value: ''
    });
    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
    
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log(response);
                setCompanies(data.data);
    
                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setCompanies([]);
            if (searchData.isSearching) {
                dispatch( searchListQuery( 'company-insurance', searchData.value, getFunction, skip, user.token ) );
            } else {
                dispatch( getCompanies( skip, getFunction, user.token ) );
            }
        }
    }, [loadData, dispatch, user.token, skip, searchData, paginatorData]);

    const searchFunction = (event) => {
        let value = event.target.value;
        if (value.length > 2) {
            stockPaginator();
            setSearchData({
                isSearching: true,
                value
            });
            setLoadData(true);
        } else {
            if (value.length === 0) {
                stockPaginator();
                setSearchData({
                    isSearching: false,
                    value: ''
                });
                setLoadData(true);
            }
        }
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }
    
    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Compañías aseguradoras</h1>
                <div className="d-flex justify-content-between">
                    <div className="d-flex w-50">
                        <input className="input-field w-75" type="text" onChange={searchFunction} placeholder="Buscar aseguradora por nombre"/>
                    </div>
                    <Link to={currentLink + "/nuevo"} className="primary-button">Añadir una nueva aseguradora +</Link>
                </div>
                <table className="list-table my-5">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Ciudad</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies.map((company, index) => (
                            <tr key={index}>
                                <td> <Link to={currentLink + `/editar/${company._id}`} key={company._id}>{company.description}</Link> </td>
                                <td> <Link to={currentLink + `/editar/${company._id}`} key={company._id}>{company.email}</Link> </td>
                                <td> <Link to={currentLink + `/editar/${company._id}`} key={company._id}>{company.city}</Link> </td>
                                <td>
                                    <BsFillTrashFill className='trash-icon' />
                                </td>
                            </tr> 
                        ))}
                    </tbody>
                </table>
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default CompaniesList;
  